"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const InfoCircle = _ref => {
  let {
    title = 'Info',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.313 14.656v-2.688h-2.625v2.688h2.625zM17.313 25.344v-8h-2.625v8h2.625zM16 5.344q5.5 0 9.406 3.906t3.906 9.406-3.906 9.406-9.406 3.906-9.406-3.906-3.906-9.406 3.906-9.406 9.406-3.906z"
  }));
};
var _default = exports.default = (0, _ikon.default)(InfoCircle);
InfoCircle.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InfoCircle",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Info'",
        "computed": false
      },
      "required": false
    }
  }
};